import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'z-1 hidden h-fit w-full bg-white py-[10px] lg:flex',
    container: 'container flex items-center gap-5'
  }
});
